import * as React from 'react';
import { Panel, FormGroup, ControlLabel, FormControl, Alert } from 'react-bootstrap';
import { IBillingDetail } from '../../../models/index';
import { IFile } from './view-edit/file';
import UploadFile from './view-edit/upload-file';

interface IProps {
    details: IBillingDetail,
    centerRoutingNumber: string,
    centerAccountNumber: string,
    hospitalW9Form: IFile,
    wasSubmittedByRecipientCenter: boolean,
    isAdmin: boolean,
    onChangeCenterRoutingNumber: (number: string) => void,
    onChangeCenterAccountNumber: (number: string) => void,
    onHospitalW9Form: (file: File) => void
}

class DirectDepositInformation extends React.Component<IProps, {}> {
    handleCenterRoutingNumberChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.props.onChangeCenterRoutingNumber(e.currentTarget.value);
    }

    handleCenterAccountNumberChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.props.onChangeCenterAccountNumber(e.currentTarget.value);
    }

    handleHospitalW9Form = (file: File) => {
        this.props.onHospitalW9Form(file);
    }

    render = () => {
        const details = this.props.details;
        const { centerRoutingNumber, centerAccountNumber, centerW9File } = details;
        const routingNumber = details.centerRoutingNumber.substring(centerRoutingNumber.length - 4);
        const accountNumber = details.centerAccountNumber.substring(centerAccountNumber.length - 4);

        return (
            <Panel>
                <Panel.Heading style={{ fontSize: 16 }}>
                    Direct Deposit Information
                </Panel.Heading>

                {details.isBillSent == false || this.props.wasSubmittedByRecipientCenter || this.props.isAdmin ?
                    <Panel.Body>
                        <Alert bsStyle='danger' style={{  fontSize: 16, padding: '5px 7.5px', textAlign: 'center' }}>These funds will be submitted back to your center once received.  To ensure payment to your center please enter the following information...</Alert>

                        <FormGroup>
                            <div className='col-xs-3'>
                                <ControlLabel className='col-xs-12' htmlFor='CenterRoutingNumber'>
                                    ACH Routing Number:
                                </ControlLabel>
                            </div>
                            <div className='col-xs-4'>
                                <FormControl
                                    maxLength={12}
                                    value={this.props.centerRoutingNumber}
                                    onChange={this.handleCenterRoutingNumberChange}
                                />
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <div className='col-xs-3'>
                                <ControlLabel className='col-xs-12' htmlFor='CenterAccountNumber'>
                                    ACH Account Number:
                                </ControlLabel>
                            </div>
                            <div className='col-xs-4'>
                                <FormControl
                                    maxLength={24}
                                    value={this.props.centerAccountNumber}
                                    onChange={this.handleCenterAccountNumberChange}
                                />
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <div className="col-xs-3">
                                <ControlLabel className='col-xs-12' htmlFor='CenterW9File'>
                                    Hospital W-9 Form:
                            </ControlLabel>
                            </div>
                            <div className="col-xs-4">
                                <UploadFile
                                    elementName="hospital-w9-form"
                                    valid={true}
                                    disable={false}
                                    onSelectFile={this.handleHospitalW9Form}
                                />

                                {this.props.hospitalW9Form != null && (
                                    <div style={{ marginTop: 10 }}>File to upload: {this.props.hospitalW9Form.file.name}</div>
                                )}

                                {details.centerW9File.length > 0 && (
                                    <div className='label label-default' style={{ display: 'block', marginTop: 5, padding: '6px 12px', fontSize: '90%' }}>An existing form is on file</div>
                                )}
                            </div>
                        </FormGroup>
                    </Panel.Body>
                    :
                    <Panel.Body>
                        {routingNumber == '' || accountNumber == '' || centerW9File == '' ?
                            <Alert bsStyle='warning' style={{  fontSize: 16, padding: '5px 7.5px', textAlign: 'center' }}>
                                We will need the ACH routing number and the ACH account number to remit funds.<br/><br/>
                                To update this information, please <a href={`center/${this.props.details.billableNephrectomy.donor.centerId}/profile/edit`} target='_blank'>click here</a>.
                            </Alert>
                            :
                            <>
                                <FormGroup>
                                    <div className='col-xs-3'>
                                        <ControlLabel className='col-xs-12' htmlFor='CenterRoutingNumber'>
                                            ACH Routing Number:
                                        </ControlLabel>
                                    </div>
                                    <div className='col-xs-4'>
                                        <div style={{ padding: "6px 12px", backgroundColor: "#ddd" }}>********{routingNumber}</div>
                                    </div>
                                </FormGroup>

                                <FormGroup>
                                    <div className='col-xs-3'>
                                        <ControlLabel className='col-xs-12' htmlFor='CenterAccountNumber'>
                                            ACH Account Number:
                                        </ControlLabel>
                                    </div>
                                    <div className='col-xs-4'>
                                        <div style={{ padding: "6px 12px", backgroundColor: "#ddd" }}>********{accountNumber}</div>
                                    </div>
                                </FormGroup>

                                <FormGroup>
                                    <div className="col-xs-3">
                                        <ControlLabel className='col-xs-12' htmlFor='CenterW9File'>
                                            Hospital W-9 Form:
                                        </ControlLabel>
                                    </div>
                                    <div className="col-xs-4">
                                        <div className='label label-default' style={{ display: 'block', marginTop: 5, padding: '6px 12px', fontSize: '90%' }}>An existing form is on file</div>
                                    </div>
                                </FormGroup>
                            </>
                        }
                    </Panel.Body>
                }
            </Panel>
        );
    }
}

export default DirectDepositInformation;